module.exports = __webpack_public_path__ + "media/images/emblems/Penthaz-coat_of_arms-849d907840a3fca46feff77b23975e1f.svg";